import {
  Directive,
  ElementRef, EventEmitter,
  HostListener,
  Input, OnInit,
  Output
} from '@angular/core';

import {StsBooleanResultModel} from '../../models/sts-boolean-result.model';
import {StsRegexBluePrintModel} from '../../models/sts-regex-blue-print.model';

@Directive({
  selector: '[app-sts-regex-input]'
})
export class StsRegexInputDirective implements OnInit {

  @Input() validateEventHook: EventEmitter<any> = new EventEmitter();
  @Input() model: StsRegexBluePrintModel;
  @Output() onValidate = new EventEmitter<StsBooleanResultModel>(false);
  private el: HTMLInputElement;

  constructor(private elementRef: ElementRef) {
    this.el = this.elementRef.nativeElement;
  }

  ngOnInit() {
    if (this.validateEventHook != null) {
      this.validateEventHook.subscribe(a => {
        this._validate(this.el.value);
      });
    }
  }

  // get ctrl() {
  @HostListener('focus', ['$event.target.value'])
  onFocus(value) {
    // this.ctrl.setValue(....);
  }

  @HostListener('blur', ['$event.target.value'])
  onBlur(value) {
    this._validate(value);
  }


  private _validate(value: string) {
    this.el.className = this.el.className.replace(
      /regex-input-error/ig, '');
    let b = this.model.regexp.test(value || '');
    if (!b) { this.el.className += ' regex-input-error'; }
    this.onValidate.emit({
      result: b,
      value: value,
      model: this.model.model
    });
  }

}
